var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeshape5B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes_x5F_2a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M401.8,281c5.6-0.9,11-2.7,14.6-7.3c1.3-1.7,3.7-4.6,3.9-6.9c-11.2-1.7-22.2-3.9-33.5,4.3 c-1.8,1.3-2.9,2.6-4.8,4l0,0c1.8,2.1,4,3.8,6.4,5.1c1.6,0.4,3.1,0.8,4.7,1C396,281.5,398.9,281.4,401.8,281z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7192BC",
    d: "M417.7,272c1.2-1.6,2.4-3.5,2.6-5.2c-11.2-1.7-22.2-3.9-33.5,4.3c-1.8,1.3-2.9,2.6-4.8,4l0,0 c1.3,1.5,2.9,2.9,4.5,4C393.5,269.5,406.6,265.7,417.7,272z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7192BC",
    d: "M419.3,269.6c0.5-1,0.9-1.9,1-2.8c-11.2-1.7-22.2-3.9-33.5,4.3c-1.8,1.3-2.9,2.6-4.8,4l0,0 c0.5,0.6,1.1,1.1,1.6,1.7C393.2,268,406.9,266.4,419.3,269.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M399.9,277.5c5.3,0,9.7-4.3,9.7-9.5c0-0.9-0.1-1.8-0.4-2.7c-6.3-0.5-12.5,0.1-18.9,3.6 C390.7,273.7,394.8,277.5,399.9,277.5z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M399.9,277.5c3.5,0,6.5-1.8,8.2-4.5c-1.1-2.9-4.3-5-8.1-5c-3.9,0-7.1,2.2-8.2,5.3 C393.6,275.8,396.5,277.5,399.9,277.5z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    fill: "#B45F2B",
    enableBackground: "new    ",
    d: "M387.3,268.3c0.8-0.6,1.6-1.2,2.5-1.7c8.6-6,18.7-6.2,28-4.4 c1,0.2,2.4,0.6,3.4,0.8c1,0.3,2.2,0.6,3.2,1c0.9,0.2,1.9,0.5,2.8,0.7c1.3,0.3,2.7,0.5,4.2,0.5c-2.4-1.4-4.9-2.9-7.3-4.3 c-1.3-0.7-2.7-1.4-4.1-2.1c-13.4-7.3-33.8-2.5-38.3,14.7C383.4,271.6,385.3,269.8,387.3,268.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#460D0D",
    d: "M408.3,254.4c-6.4-0.9-13.2,0.1-18.6,3.8c-3.7,2.5-8.2,6.7-9.1,11.5c8.2-15.5,29.6-17.2,43.7-8.7 C420.5,256.6,413.8,255.2,408.3,254.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#450F0C",
    d: "M399.1,272.1c3,0,5.5-2.5,5.5-5.5c0-0.5-0.1-1-0.2-1.4c-3.6,0.1-7.1,0.7-10.7,2.1 C394,270,396.3,272.1,399.1,272.1z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 399.7,
    cy: 268,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 395,
    cy: 270.6,
    r: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 401.2,
    cy: 272,
    rx: 3,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#460D0D",
    d: "M422.9,266.9c5.1,0.1,7.5-0.3,10.2-1.7c-0.6,0-1.2,0-1.7,0c-1.5-0.1-2.9-0.3-4.2-0.5 c-1-0.2-1.9-0.4-2.8-0.7c-1-0.3-2.2-0.7-3.2-1s-2.4-0.6-3.4-0.8c-9.3-1.8-19.5-1.6-28,4.4c-0.9,0.5-1.7,1.1-2.5,1.7 c-2,1.5-3.9,3.3-5.5,5.2c-1,1.2-2,2.4-2.9,3.7c-0.2,0.3-0.8,1.3-1.2,2.1c1.5-1.5,3.1-3.2,4.4-4.2l0,0c1.8-1.4,2.9-2.7,4.8-4 c11.3-8.3,22.3-6,33.5-4.3c-0.2,2.3-2.6,5.2-3.9,6.9c-3.6,4.6-9,6.4-14.6,7.3c-2.9,0.5-5.7,0.6-8.6,0.2c-1.6-0.2-3.2-0.6-4.7-1 c3.3,1.8,7,2.8,11,3C413.1,282.7,420.5,274.3,422.9,266.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M312.6,281c-5.6-0.9-11-2.7-14.6-7.3c-1.3-1.7-3.7-4.6-3.9-6.9c11.2-1.7,22.2-3.9,33.5,4.3 c1.8,1.3,2.9,2.6,4.8,4l0,0c-1.8,2.1-4,3.8-6.4,5.1c-1.6,0.4-3.1,0.8-4.7,1C318.3,281.5,315.5,281.4,312.6,281z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7192BC",
    d: "M296.6,272c-1.2-1.6-2.4-3.5-2.6-5.2c11.2-1.7,22.2-3.9,33.5,4.3c1.8,1.3,2.9,2.6,4.8,4l0,0 c-1.3,1.5-2.9,2.9-4.5,4C320.8,269.5,307.7,265.7,296.6,272z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7192BC",
    d: "M295.1,269.6c-0.5-1-0.9-1.9-1-2.8c11.2-1.7,22.2-3.9,33.5,4.3c1.8,1.3,2.9,2.6,4.8,4l0,0 c-0.5,0.6-1.1,1.1-1.6,1.7C321.1,268,307.4,266.4,295.1,269.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M314.5,277.5c-5.3,0-9.7-4.3-9.7-9.5c0-0.9,0.1-1.8,0.4-2.7c6.3-0.5,12.5,0.1,18.9,3.6 C323.6,273.7,319.5,277.5,314.5,277.5z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M314.5,277.5c-3.5,0-6.5-1.8-8.2-4.5c1.1-2.9,4.3-5,8.1-5c3.9,0,7.1,2.2,8.2,5.3 C320.8,275.8,317.8,277.5,314.5,277.5z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    fill: "#B45F2B",
    enableBackground: "new    ",
    d: "M327.1,268.3c-0.8-0.6-1.6-1.2-2.5-1.7 c-8.6-6-18.7-6.2-28-4.4c-1,0.2-2.4,0.6-3.4,0.8c-1,0.3-2.2,0.6-3.2,1c-0.9,0.2-1.9,0.5-2.8,0.7c-1.3,0.3-2.7,0.5-4.2,0.5 c2.4-1.4,4.9-2.9,7.3-4.3c1.3-0.7,2.7-1.4,4.1-2.1c13.4-7.3,33.8-2.5,38.3,14.7C330.9,271.6,329.1,269.8,327.1,268.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#460D0D",
    d: "M306,254.4c6.4-0.9,13.2,0.1,18.6,3.8c3.7,2.5,8.2,6.7,9.1,11.5c-8.2-15.5-29.6-17.2-43.7-8.7 C293.8,256.6,300.6,255.2,306,254.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#450F0C",
    d: "M315.2,272.1c-3,0-5.5-2.5-5.5-5.5c0-0.5,0.1-1,0.2-1.4c3.6,0.1,7.1,0.7,10.7,2.1 C320.3,270,318,272.1,315.2,272.1z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 314.6,
    cy: 268,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 319.3,
    cy: 270.6,
    r: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 313.1,
    cy: 272,
    rx: 3,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#460D0D",
    d: "M335.5,277.3c-0.9-1.3-1.9-2.5-2.9-3.7c-1.7-1.9-3.5-3.7-5.5-5.2c-0.8-0.6-1.6-1.2-2.5-1.7 c-8.6-6-18.7-6.2-28-4.4c-1,0.2-2.4,0.6-3.4,0.8c-1,0.3-2.2,0.6-3.2,1c-0.9,0.2-1.9,0.5-2.8,0.7c-1.3,0.3-2.7,0.5-4.2,0.5 c-0.6,0-1.1,0-1.7,0c2.7,1.4,5.1,1.8,10.2,1.7c2.4,7.4,9.8,15.8,23.6,16.3c3.9-0.2,7.7-1.2,11-3c-1.6,0.4-3.1,0.8-4.7,1 c-2.9,0.4-5.7,0.3-8.6-0.2c-5.6-0.9-11-2.7-14.6-7.3c-1.3-1.7-3.7-4.6-3.9-6.9c11.2-1.7,22.2-3.9,33.5,4.3c1.8,1.3,2.9,2.6,4.8,4 l0,0c1.3,1,3,2.7,4.4,4.2C336.2,278.5,335.7,277.6,335.5,277.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeshape5B);
export default __webpack_public_path__ + "static/media/eyeshape_5b.93b0660a192e4dc15276fa4a81ff1da7.svg";
export { ForwardRef as ReactComponent };